import Card from "./card.js";
export default class ImageOnly extends Card {
  constructor(s, t, i, h, r, e, l, n, o, a, u, c, d, m) {
    super(s, t, null, i, null, h, r, e, l, n, o, a, u, c, d, m),
      (this._ = "ab-image-only"),
      (this.S = !1),
      (this.test = !1);
  }
  Y() {
    const s = {};
    return (
      (s[Card.tt.Z] = Card.it.Gt),
      (s[Card.tt.ht] = this.id),
      (s[Card.tt.et] = this.viewed),
      (s[Card.tt.ot] = this.imageUrl),
      (s[Card.tt.nt] = this.updated),
      (s[Card.tt.dt] = this.created),
      (s[Card.tt.ut] = this.categories),
      (s[Card.tt.lt] = this.expiresAt),
      (s[Card.tt.URL] = this.url),
      (s[Card.tt.ft] = this.linkText),
      (s[Card.tt.xt] = this.aspectRatio),
      (s[Card.tt.bt] = this.extras),
      (s[Card.tt.gt] = this.pinned),
      (s[Card.tt.jt] = this.dismissible),
      (s[Card.tt.zt] = this.clicked),
      (s[Card.tt.kt] = this.test),
      s
    );
  }
}
